<template>
  <div>
    <div v-for="(value, key) in data" :key="key" class="base-modal-line">
      <div v-if="isPrimitive(value)" class="item-full">
        <div class="item-title">{{ key }}:</div>
        <div class="item-value">{{ value }}</div>
      </div>
      <div v-else-if="isArray(value)" class="item-full">
        <div class="item-title">{{ key }}:</div>
        <div class="item-value">{{ value.join(' - ') }}</div>
      </div>
      <div v-else-if="isArrayOfObjects(value)" class="item-full">
        <div class="item-title">{{ key }}</div>
        <Table :columns="getColumns(value)" :data="value" border></Table>
      </div>
      <div v-else-if="isObject(value)" class="item-full">
        <div class="item-title">{{ key }}</div>
        <div class="item-value">
          <RecursiveRenderer :data="value" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Table } from "view-design";

export default {
  components: {
    Table,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  methods: {
    isPrimitive(value) {
      return typeof value === "string" || typeof value === "number" || typeof value === "boolean";
    },
    isArray(value) {
      return Array.isArray(value) && value.every((item) => typeof item !== "object");
    },
    isArrayOfObjects(value) {
      return Array.isArray(value) && value.every((item) => typeof item === "object");
    },
    isObject(value) {
      return typeof value === "object" && !Array.isArray(value) && value !== null;
    },
    getColumns(array) {
      if (!array.length) return [];
      return Object.keys(array[0]).map((key) => ({
        title: key,
        key: key,
      }));
    },
  },
};
</script>
<style scoped>
  .base-modal-line {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 10px;
  }
  .item-half {
    flex: 0 0 48%;
    margin-right: 2%;
    display: flex;
    align-items: center;
  }
  .item-right {
    margin-right: 0;
  }
  .item-full {
    flex: 0 0 100%;
    margin-bottom: 10px;
  }
  .item-title {
    font-weight: bold;
    margin-right: 10px;
  }
  .item-value {
    flex: 1;
  }
</style>

